import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { InsuranceFlowStatus } from 'src/app/_enums/insurance-flow/insurance-flow-status.enum';
import { SendLeadModalEnum } from 'src/app/_enums/send-lead-modal.enum';
import { Lead } from 'src/app/_types/lead.types';
import { getSendLeadModal } from 'src/app/Dashboard/proposals/task-details/components/task-history/stepper-actions/send-lead/send-lead-modal.helpers';
import { SendGroupeMutuelLeadModalComponent } from 'src/app/shared/components/lead-details/send-lead-modal/send-groupe-mutuel-modal/send-groupe-mutuel-modal.component';
import { SendLeadBase } from 'src/app/shared/components/lead-details/send-lead-modal/send-lead.base';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-send-lead-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    IconsModule,
    SendGroupeMutuelLeadModalComponent,
    // Add future insurer modal components here
  ],
  templateUrl: './send-lead.component.html',
})
export class SendLeadActionComponent extends BaseStepperAction {
  readonly SendLeadModalEnum = SendLeadModalEnum;

  @ViewChild('insurerModal') insurerModal?: SendLeadBase;

  get enabled(): boolean {
    return (
      this.state?.insuranceFlowData?.status === InsuranceFlowStatus.PENDING_LEAD
    );
  }

  get lead(): Lead {
    return this.state?.lead;
  }

  get activeInsurerModal(): SendLeadModalEnum | null {
    return getSendLeadModal(this.lead);
  }

  openInsurerModal(): void {
    if (this.insurerModal) this.insurerModal.openModal();
  }
}
